import React from "react";
import Modal from "../modal";

class VideoRecordTutorialModal extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <Modal width="800px">
        <div className="head">MyStrengthBook Screen-recording + Voice-over</div>
        <div className="body welcome video-record-modal">
          <a
            href="https://youtu.be/ZLVZAEQOSCk"
            target="_blank"
            rel="noopener noreferrer"
            className="button"
          >
            <img src="/img/svg/play.svg" alt="play" className="icon-white" />
            Play
          </a>
          <p>
            This feature helps you streamline check-ins and provide enhanced
            feedback to your athletes. You can record yourself watching and
            drawing on lifter videos, explaining protocols, and reviewing
            training metrics. Use this feature to provide asynchronous
            communication with your athletes.
          </p>
          <p> How it works:</p>

          <ul>
            <li>Click the record button</li>
            <li>Give permission to your microphone and camera</li>
            <li>Choose the window you want to record</li>
            <li>Configure your microphone and camera settings</li>
            <li>Start recording</li>
            <li>Click stop when you are finished recording</li>
            <li>
              Lastly, click "Insert Link" to save the video and notify your
              athlete
            </li>
            <li>
              Your athlete will receive a notification and they can watch the
              video in-app
            </li>
          </ul>

          <p>
            Loom is the 3rd party screen recording tool we integrated with.
            MyStrengthBook customers gain free access to this service when using
            the embedded version.
          </p>

          <p> The current browser compatiibility is as follows: </p>

          <ul>
            <li>Google Chrome v90+</li>
            <li>Microsoft Edge v90+</li>
            <li>Brave v1.22+</li>
          </ul>

          <p> Coming soon: </p>

          <ul>
            <li>Firefox</li>
            <li>Safari</li>
          </ul>

          <p>Note: This will not work in incognito mode or private browsing.</p>

          <p>
            Drawing tool: We recommend using the Chrome extension "Web Paint" as
            a drawing tool.
          </p>
        </div>
      </Modal>
    );
  }
}

export default VideoRecordTutorialModal;
